import { Link } from "react-router-dom";

// Owner data used across privacy / terms texts (single source of truth).
export const OWNER = {
  name: "Az. Agr. Tombetò di Matricardi Elisa",
  brand: "Il Pozzo dei Giganti",
  address: "Contrada San Rustico 60, 63815 Monte San Pietrangeli (FM)",
  vat: "02489330445",
  cf: "MTRLSE85P63I324I",
  email: "ilpozzodeigiganti@gmail.com",
  phone: "+39 351 3120603",
  site: "menu.ilpozzodeigiganti.it",
};

export function LegalLinks({ className = "", light = false }) {
  const c = light ? "text-[#f7ebdf]/70 hover:text-[#f7ebdf]" : "text-[#7c5a4e] hover:text-[#4a1c17]";
  return (
    <nav className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] ${className}`} data-testid="legal-links">
      <Link to="/privacy" className={`${c} underline-offset-2 hover:underline`} data-testid="legal-link-privacy">Privacy</Link>
      <span className={light ? "text-[#f7ebdf]/30" : "text-[#e8dcc8]"}>·</span>
      <Link to="/cookie" className={`${c} underline-offset-2 hover:underline`} data-testid="legal-link-cookie">Cookie</Link>
      <span className={light ? "text-[#f7ebdf]/30" : "text-[#e8dcc8]"}>·</span>
      <Link to="/termini" className={`${c} underline-offset-2 hover:underline`} data-testid="legal-link-terms">Termini</Link>
    </nav>
  );
}

// One-liner under submit buttons: information duty satisfied without an extra mandatory checkbox.
export function ConsentNote({ action = "Proseguendo", light = false, className = "" }) {
  const base = light ? "text-[#f7ebdf]/70" : "text-[#7c5a4e]";
  const link = light ? "text-[#f7ebdf] underline" : "text-[#4a1c17] underline";
  return (
    <p className={`text-[11px] leading-snug text-center ${base} ${className}`} data-testid="consent-note">
      {action} confermi di aver letto l'<Link to="/privacy" className={link}>Informativa privacy</Link> e accetti i <Link to="/termini" className={link}>Termini</Link>.
    </p>
  );
}

// Optional, unticked marketing opt-in with positive framing (GDPR-valid consent, low friction).
export function MarketingOptIn({ checked, onChange, light = false, testId = "marketing-optin" }) {
  const base = light ? "text-[#f7ebdf]/90" : "text-[#4a1c17]";
  return (
    <label className={`flex items-start gap-2.5 text-xs leading-snug cursor-pointer ${base}`} data-testid={testId}>
      <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 rounded border-[#C48B31] accent-[#4a1c17]" data-testid={`${testId}-checkbox`} />
      <span>
        <b>Sì, tienimi aggiornato</b> su eventi, menu di stagione e offerte riservate via WhatsApp ed email. Puoi disiscriverti quando vuoi.
      </span>
    </label>
  );
}
